import { qprConstants } from '../Constants'
const qprReducer = (state = {}, action) => {
  switch (action.type) {
    case qprConstants.QPR_SUCCESS:
      return action.payload;
    case qprConstants.QPR_FAILURE:
      return {};
    default:
      return state;
  }
}

export default qprReducer;